import GAManager from "../ga/GAManager";
import Fader from "../common/view/Fader";
import Intro from "./Intro";
import Loading from "./Loading";
import QuizItem from "./QuizItem";
import { CATEGORY_NAME } from "../constants/variables";

class Quiz {
  // ---------------------------------------------------------------------------------------------------------
  // --	Quiz
  // ---------------------------------------------------------------------------------------------------------

  constructor() {
    console.log("Quiz");

    //GA初期化
    GAManager.ready();

    //カテゴリーインデックス
    this.catIndex = 0;

    //結果データ
    this.answers = "";

    //フェーダー
    this.fader = new Fader();

    //イントロ生成
    this.intro = new Intro();

    //ローディング生成
    this.loading = new Loading();

    //クイズアイテム保持用の配列
    this.items = [];

    //もどるボタン
    $(".js-btn-back").on("click", (e) => {
      this.back();
      return false;
    });

    //次へボタン
    $(".js-btn-next").on("click", (e) => {
      if (this.check()) this.next();
      return false;
    });

    //採点ボタン
    $(".js-btn-grade").on("click", (e) => {
      if (this.check()) this.next();
      return false;
    });

    //CSV読み込み
    this.loadCsv();
  }

  // start() {
  // }

  /**
   * CSV読み込み
   */
  loadCsv() {
    $.get("./assets/data/data.csv").done((csv) => {
      this.models = $.csv.toObjects(csv);
      // console.log(this.models);
      this.loadTemplate();
    });
  }

  /**
   * テンプレート読み込み
   */
  loadTemplate() {
    //テンプレート読み込み
    $.get("./assets/data/q-item.tmpl.html").done((data) => {
      this.tmpl = $.templates(data);
      this.next();
      //画面を離れる時用のアラート
      window.onbeforeunload = function (e) {
        e.returnValue = "";
      };
    });
  }

  /**
   * 戻る
   */
  back() {
    //インデックス減らす
    this.catIndex--;

    //TOPへ戻る
    if (this.catIndex <= 0) {
      window.onbeforeunload = null;
      location.href = "index.html";
      return;
    }
    //前の設問にもどる
    else {
      this.startQuiz();
    }
  }

  /**
   * 次のカテゴリー表示
   */
  next() {
    //インデックス増加
    this.catIndex++;

    //結果ページに遷移
    if (this.catIndex >= 6) {
      this.showResult();
      return;
    }

    //スタート
    this.startQuiz();
  }

  /**
   * 問題スタート
   */
  startQuiz() {
    //イントロ表示
    this.intro.show(this.catIndex - 1);
    this.intro.once("READY", () => {
      this.render();
    });
  }

  /**
   * レンダリング
   */
  render() {
    //カテゴリークラス
    const catClass = "cat" + this.catIndex;

    //進捗タブの更新
    $(".pg-quiz__category-item")
      .eq(this.catIndex - 1)
      .addClass("visit");

    //タイトルの更新
    const title = $(".pg-quiz__title");
    title.removeClass("cat" + (this.catIndex - 1));
    title.addClass(catClass);
    title.find("strong").empty();
    title.find("strong").text(CATEGORY_NAME[this.catIndex] + " ");

    //リストのレンダリング
    const models = this.models.filter((model) => model.cat === catClass);
    var result = this.tmpl.render({ models: models });
    $(".pg-quiz__q-list").html(result);

    //結果がある場合
    let selectedAnswers;
    if (this.answers.length > 4 * (this.catIndex - 1)) {
      selectedAnswers = this.answers.substr((this.catIndex - 1) * 4, 4);
      this.answers = this.answers.substring(0, (this.catIndex - 1) * 4);
    }

    //アイテムをクラス化
    const holder = this;
    this.items = [];
    $(".pg-quiz__q-list")
      .find(".pg-quiz__q-item")
      .each(function (index) {
        const item = new QuizItem($(this), index);
        item.on("UPDATE", holder.onItemUpdate.bind(holder));
        holder.items.push(item);
        if (selectedAnswers) {
          item.update(parseInt(selectedAnswers.charAt(index)));
        }
      });

    //戻るボタンの表示制御
    if (this.catIndex <= 1) {
      $(".js-btn-back").hide();
      $(".pg-quiz__ui-container").addClass("first");
    } else {
      $(".js-btn-back").show();
      $(".pg-quiz__ui-container").removeClass("first");
    }

    //次へボタンの表示変更
    if (this.catIndex < 5) {
      $(".js-btn-next").show();
      $(".js-btn-grade").hide();
    } else {
      $(".js-btn-next").hide();
      $(".js-btn-grade").show();
    }

    //ページの一番上に戻す
    $("body, html").animate({ scrollTop: 0 }, 10);
  }

  /**
   * 入力内容チェック
   */
  check() {
    //未選択アイテムを抽出
    let answers = "";
    let unSelectedItem = null;
    this.items.forEach((item) => {
      if (!item.check()) {
        if (!unSelectedItem) unSelectedItem = item;
      }
      answers += item.selectedVal;
    });

    //未選択アイテムのところへスクロール
    if (unSelectedItem) {
      $("body, html").animate({ scrollTop: unSelectedItem.getTop() - 60 }, 500);
      return false;
    } else {
      this.answers += answers;
      // console.log("this.answers:" + this.answers);
      return true;
    }
  }

  /**
   * アイテム選択
   */
  onItemUpdate(updateItem) {
    //オフセット
    let offset = $(window).scrollTop() - updateItem.getTop();

    //選択されていないアイテムを参照
    let unselectedItem = null;
    for (let i = updateItem.index; i < this.items.length; i++) {
      const item = this.items[i];
      if (!item.isSelected()) {
        unselectedItem = item;
        break;
      }
    }

    //選択されていないアイテムがあればスクロール
    if (unselectedItem) {
      $("body, html").animate(
        { scrollTop: unselectedItem.getTop() + offset },
        400
      );
    }
  }

  // ---------------------------------------------------------------------------------------------------------
  // --	結果ページへ遷移
  // ---------------------------------------------------------------------------------------------------------

  showResult() {
    //モデルに回答を反映
    let total = 0;
    const len = this.models.length;
    for (let i = 0; i < len; i++) {
      //モデルに正解不正解を反映
      const model = this.models[i];
      model.selected = this.answers.charAt(i);
      model.isCorrect = model.correct === model.selected;

      //トータルスコアを計算
      if (model.isCorrect) total += 5;

      //正解不正解をGAに送信
      const label = model.isCorrect ? "正解" : "不正解";
      GAManager.gtag("quizAnswerCount", "Q" + model.no + "_" + label);
    }

    //結果をGAに送信
    let resultLabel = "スコア" + total;
    if (total == 100) {
      resultLabel += "_マスター";
    } else if (total >= 90) {
      resultLabel += "_ダイヤモンド";
    } else if (total >= 80) {
      resultLabel += "_プラチナ";
    } else if (total >= 70) {
      resultLabel += "_ゴールド";
    } else if (total >= 50) {
      resultLabel += "_シルバー";
    } else {
      resultLabel += "_ブロンズ";
    }
    GAManager.gtag("quizResultCount", resultLabel);

    //ローディングを表示した後に画面遷移
    this.loading.show(() => {
      window.onbeforeunload = null;
      location.href = "result.html?answers=" + this.answers;
    });
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default Quiz;
